import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import { getCrmSupplierContactQuotasEndpointIdentifier } from './use-get-crm-supplier-contact-quotas-api';

const endpoint = 'ums/v1/crm/management/suppliers/contact-quotas';

type TData = void;
type TError = AxiosError;
type TVariables = number;

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

export function useDeleteCrmSupplierContactQuotaApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async (id: TVariables): Promise<TData> => {
    await http.delete(`${endpoint}/${id}`);
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: endpoint,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([getCrmSupplierContactQuotasEndpointIdentifier]);
      queryClient.invalidateQueries([endpoint, variables]);
      if (userOnSuccess) {
        userOnSuccess(data, variables, context);
      }
    },
    ...restOptions,
  });
}
